export default function RogersDestinationsSection() {
  return (
    <section id="destinations" className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Popular Destinations</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">Where Rogers Travelers Are Going</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            { dest: "China & Japan", icon: "ri-building-2-line", desc: "Walmart supplier visits and tech conference trips. Year-round corporate travel with peaks in Q1 and Q3." },
            { dest: "European River Cruises", icon: "ri-ship-line", desc: "Rhine and Danube cruises. Popular with Bentonville and Rogers families and retirees." },
            { dest: "Caribbean & Mexico", icon: "ri-sun-line", desc: "Family vacations from Dallas or Houston cruise ports. Spring break and summer peaks." },
            { dest: "UK & Germany", icon: "ri-plane-line", desc: "Corporate travel for NWA manufacturing and retail executives. Trade shows in Dusseldorf and London." },
          ].map((d) => (
            <div key={d.dest} className="bg-[#F7F8FA] rounded-lg p-6 text-center hover:bg-[#EEF2F8] transition-all">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-white mx-auto mb-4"><i className={`${d.icon} text-[#1A365D] text-2xl`}></i></div>
              <h3 className="font-bold text-[#1A365D] mb-2">{d.dest}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{d.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}